import gql from 'graphql-tag';
import communityInfoFragment from '../community/communityInfo';
import communityMetaFragment from '../community/communityMetaData';

export default gql`
  fragment channelInfo on Channel {
    id
    name
    slug
    description
    isPrivate
    createdAt
    isArchived
    channelPermissions {
      isMember
      isPending
      isBlocked
      isOwner
      isModerator
      receiveNotifications
    }
    community {
      ...communityInfo
      ...communityMetaData
    }
  }
  ${communityInfoFragment}
  ${communityMetaFragment}
`;
